var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "training-page" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "training-container" }, [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "training-skeleton-list" },
              _vm._l(5, function(i) {
                return _c(
                  "div",
                  { key: i, staticClass: "training-skeleton-card" },
                  [
                    _c("div", { staticClass: "skeleton-thumb" }),
                    _vm._v(" "),
                    _vm._m(1, true)
                  ]
                )
              }),
              0
            )
          : _vm.trainingList.length > 0
          ? _c(
              "div",
              { staticClass: "training-list" },
              _vm._l(_vm.trainingList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "course-card-h",
                    on: {
                      click: function($event) {
                        return _vm.onClickItem(item)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "card-thumb" }, [
                      _c("div", { staticClass: "thumb-skeleton" }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "thumb-img",
                        attrs: { src: _vm.getThumb(item), alt: item.Subject }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-content" }, [
                      _c("h4", { staticClass: "card-title" }, [
                        _vm._v(_vm._s(item.Subject))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-footer" }, [
                        item.Status === 1
                          ? _c(
                              "span",
                              { staticClass: "card-status unlocked" },
                              [_vm._v("已完成")]
                            )
                          : _c("span", { staticClass: "card-status locked" }, [
                              _vm._v(
                                "进度 " + _vm._s(_vm.getProgress(item)) + "%"
                              )
                            ]),
                        _vm._v(" "),
                        _vm.getItemType(item)
                          ? _c("span", { staticClass: "content-type-tag" }, [
                              _vm._v(_vm._s(_vm.getItemType(item)))
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loading && _vm.trainingList.length === 0
          ? _c("div", { staticClass: "empty-state" }, [
              _c("div", { staticClass: "empty-icon" }, [_vm._v("📚")]),
              _vm._v(" "),
              _c("p", { staticClass: "empty-title" }, [_vm._v("暂无培训记录")]),
              _vm._v(" "),
              _c("p", { staticClass: "empty-desc" }, [
                _vm._v("开始学习课程后，这里会显示您的学习进度")
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          staticClass: "study-confirm-dialog",
          attrs: {
            "show-confirm-button": false,
            "show-cancel-button": false,
            "lock-scroll": false,
            "close-on-click-overlay": true,
            "get-container": "body"
          },
          on: {
            closed: function($event) {
              _vm.selectedItem = null
            }
          },
          model: {
            value: _vm.showGoStudyConfirm,
            callback: function($$v) {
              _vm.showGoStudyConfirm = $$v
            },
            expression: "showGoStudyConfirm"
          }
        },
        [
          _c("div", { staticClass: "confirm-dialog-content" }, [
            _c("div", { staticClass: "confirm-dialog-thumb" }, [
              _c("img", {
                attrs: {
                  src: _vm.selectedItem ? _vm.getThumb(_vm.selectedItem) : "",
                  alt: ""
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "confirm-dialog-title" }, [
              _vm._v(_vm._s(_vm.selectedItem ? _vm.selectedItem.Subject : ""))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "confirm-dialog-tip" }, [
              _vm._v("是否继续学习该课程？")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "confirm-dialog-actions" }, [
              _c(
                "button",
                {
                  staticClass: "dialog-btn cancel",
                  on: { click: _vm.closeGoStudyConfirm }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "dialog-btn confirm",
                  on: { click: _vm.goStudy }
                },
                [_vm._v("前往学习")]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "header-content" }, [
        _c("h1", { staticClass: "page-title" }, [_vm._v("🎯 培训记录")]),
        _vm._v(" "),
        _c("p", { staticClass: "page-subtitle" }, [_vm._v("记录您的学习历程")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skeleton-content" }, [
      _c("div", { staticClass: "skeleton-line skeleton-title-line" }),
      _vm._v(" "),
      _c("div", { staticClass: "skeleton-line skeleton-title-line-short" }),
      _vm._v(" "),
      _c("div", { staticClass: "skeleton-footer" }, [
        _c("div", { staticClass: "skeleton-line skeleton-status" }),
        _vm._v(" "),
        _c("div", { staticClass: "skeleton-line skeleton-tag" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75c8b7b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c8b7b9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/training_list.vue
// module id = null
// module chunks = 